"use strict";

exports.__esModule = true;
exports.AcalaBalanceAdapter = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _ethers = require("ethers");
var _operators = require("rxjs/operators");
var _errors = require("../errors");
var _storage = require("../../utils/storage");
var _erc20Adapter = require("./erc20-adapter");
const createStorages = api => {
  return {
    nativeBalance: address => _storage.Storage.create({
      api: api,
      query: api.query.system.account,
      params: [address]
    }),
    nonNativeBalance: (token, address) => _storage.Storage.create({
      api: api,
      query: api.query.tokens.accounts,
      params: [address, token.toChainData()]
    }),
    issuance: token => {
      const nativeTokenName = api.registry.chainTokens[0];
      const isNativeToken = (0, _sdkCore.forceToCurrencyName)(nativeTokenName) === (0, _sdkCore.forceToCurrencyName)(token);
      return _storage.Storage.create({
        api: api,
        query: isNativeToken ? api.query.balances.totalIssuance : api.query.tokens.totalIssuance,
        params: isNativeToken ? [] : [token.toChainData()]
      });
    }
  };
};
class AcalaBalanceAdapter {
  constructor(_ref) {
    let {
      api,
      evmProvider
    } = _ref;
    this.storages = void 0;
    this.nativeCurrency = void 0;
    this.evmProvider = void 0;
    this.erc20Adapter = void 0;
    this.api = void 0;
    this.transformNative = (data, token) => {
      const free = _sdkCore.FixedPointNumber.fromInner(data.data.free.toString(), token.decimals);
      const locked = _sdkCore.FixedPointNumber.fromInner((data.data.miscFrozen || data.data.frozen).toString(), token.decimals);
      const reserved = _sdkCore.FixedPointNumber.fromInner(data.data.reserved.toString(), token.decimals);
      const available = free.sub(locked).max(_sdkCore.FixedPointNumber.ZERO);
      return {
        available,
        free,
        locked,
        reserved
      };
    };
    this.transformNonNative = (data, token) => {
      const free = _sdkCore.FixedPointNumber.fromInner(data.free.toString(), token.decimals);
      const locked = _sdkCore.FixedPointNumber.fromInner(data.frozen.toString(), token.decimals);
      const reserved = _sdkCore.FixedPointNumber.fromInner(data.reserved.toString(), token.decimals);
      const available = free.sub(locked).max(_sdkCore.FixedPointNumber.ZERO);
      return {
        available,
        free,
        locked,
        reserved
      };
    };
    this.api = api;
    this.storages = createStorages(this.api);
    this.nativeCurrency = api.registry.chainTokens[0];
    if (evmProvider) {
      this.evmProvider = evmProvider;
      this.erc20Adapter = new _erc20Adapter.ERC20Adapter(this.evmProvider);
    }
  }
  subscribeBalance(token, address) {
    const {
      nativeCurrency
    } = this;
    const isNativeToken = nativeCurrency === token.name;
    if (!token.isERC20 && _ethers.utils.isAddress(address)) {
      throw new _errors.NotSupportETHAddress(address);
    }
    if (token.isERC20 && !this.evmProvider) {
      throw new _errors.NotSupportEVMBalance();
    }
    if (token.isERC20) {
      return this.erc20Adapter.subscribeBalance(token, address);
    }
    if (isNativeToken) {
      const storage = this.storages.nativeBalance(address);
      return storage.observable.pipe((0, _operators.map)(data => this.transformNative(data, token)));
    }

    // nonNative token
    const storage = this.storages.nonNativeBalance(token, address);
    return storage.observable.pipe((0, _operators.map)(data => this.transformNonNative(data, token)));
  }
  getED(token) {
    return token.ed;
  }
  subscribeIssuance(token) {
    if (token.isERC20 && !this.evmProvider) {
      throw new _errors.NotSupportEVMBalance();
    }
    if (token.isERC20) {
      return this.erc20Adapter.subscribeIssuance(token);
    }
    const storage = this.storages.issuance(token);
    const handleIssuance = (data, token) => _sdkCore.FixedPointNumber.fromInner(data.toString(), token.decimals);
    return storage.observable.pipe((0, _operators.map)(data => handleIssuance(data, token)));
  }
}
exports.AcalaBalanceAdapter = AcalaBalanceAdapter;